import { Link } from "react-router-dom";
import type { Business } from "@/types/directory";
import BusinessCard from "@/components/base/BusinessCard";

interface FeaturedListingsProps {
  businesses: Business[];
}

export default function FeaturedListings({ businesses }: FeaturedListingsProps) {
  if (businesses.length === 0) {
    return null;
  }

  return (
    <section className="border-y border-[#A6DCC8] bg-[#CFF1E6]">
      <div className="mx-auto w-full max-w-[1400px] px-6 py-14 md:py-16">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="mb-2 inline-flex items-center gap-2 rounded-full bg-[#0F5132] px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-[#CFF1E6]">
              <span className="flex h-4 w-4 items-center justify-center text-[#8FE0C0]">
                <i className="ri-vip-crown-2-line text-sm" />
              </span>
              Featured
            </span>
            <h2 className="font-heading text-2xl font-bold leading-tight text-[#0B3B29] md:text-3xl">
              Featured businesses worth knowing
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-[#2F5D4B] md:text-base">
              {businesses.length} premium listings handpicked from across South Canara, Udupi and
              North Canara.
            </p>
          </div>

          <Link
            to="/directory"
            className="group inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-[#0F5132] px-4 py-2.5 text-sm font-semibold text-[#CFF1E6] transition-colors duration-200 hover:bg-[#0B3F27]"
          >
            Browse all businesses
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line text-base transition-transform duration-200 group-hover:translate-x-0.5" />
            </span>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {businesses.map((business) => (
            <BusinessCard key={business.id} business={business} clickableCard />
          ))}
        </div>
      </div>
    </section>
  );
}